import {
  PrimaryNavIdentifier,
  SecondaryNavIdentifier,
  SecondaryNavItem,
} from '@zola-helpers/client/dist/es/constants/navConstants';
import { UserContext } from 'actions/UserActions';

export const getInvitesSecondaryItems = (userContext: UserContext) => {
  const draftsAndOrders = {
    path: '/wedding-planning/projects/drafts',
    title: 'Drafts and orders',
    id: SecondaryNavIdentifier.PAPER_DRAFTS_AND_ORDERS,
    parent: PrimaryNavIdentifier.PAPER,
  };

  const shopUniversal = {
    path: '/wedding-planning/universal',
    title: 'Shop invites and paper',
    id: SecondaryNavIdentifier.PAPER_SHOP,
    parent: PrimaryNavIdentifier.PAPER,
  };

  const favorites = {
    path: '/favorites/paper',
    title: 'Favorites',
    id: SecondaryNavIdentifier.YOUR_FAVORITES,
    parent: PrimaryNavIdentifier.PAPER,
  };

  return userContext.has_invitation_account
    ? [shopUniversal, draftsAndOrders, favorites]
    : [shopUniversal, favorites];
};

export const getGuestListSecondaryItems = () => {
  const events = {
    path: '/wedding/manage/events',
    title: 'Events',
    id: SecondaryNavIdentifier.EVENTS,
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };
  const superLink = {
    path: '/wedding/manage/guests/collection-link',
    title: 'Contact Collector',
    id: SecondaryNavIdentifier.SUPER_LINK,
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };
  const hotelBlocks = {
    title: 'Hotel blocks',
    path: 'https://zola.hotelplanner.com/Group-Rate/?kw=guestnav',
    parent: PrimaryNavIdentifier.GUEST_LIST,
  };

  const guestList: SecondaryNavItem = {
    path: '/wedding/manage/guests/all',
    title: 'Guest list',
    id: SecondaryNavIdentifier.ALL_GUESTS,
    parent: PrimaryNavIdentifier.GUEST_LIST,
    showCaret: false,
  };
  return [guestList, superLink, events, hotelBlocks];
};

export const getWebsiteSecondaryItems = (userContext: UserContext) => {
  if (!userContext.has_website) {
    return [];
  }
  const manageWebsite = {
    id: SecondaryNavIdentifier.MANAGE,
    path: '/wedding/manage/website/manage',
    title: 'Manage website',
    parent: PrimaryNavIdentifier.WEBSITE,
  };

  const editWebsite = {
    id: SecondaryNavIdentifier.EDIT,
    path: '/wedding/manage/website/pages/home',
    title: 'Edit website',
    parent: PrimaryNavIdentifier.WEBSITE,
  };

  return [manageWebsite, editWebsite];
};

export const getAlbumsSecondaryItems = (userContext: UserContext) => {
  const parent = PrimaryNavIdentifier.ALBUMS;

  const albumsOrdersAndDrafts = {
    title: 'Drafts and orders',
    path: '/wedding-albums/drafts',
    id: SecondaryNavIdentifier.ALBUMS_DRAFTS,
    parent,
  };

  const shopAlbums = {
    title: 'Shop albums',
    path: '/wedding-albums/shop',
    id: SecondaryNavIdentifier.ALBUMS_SHOP,
    parent,
  };

  const showOrdersAndDrafts =
    userContext.has_invitation_account &&
    userContext.invitation_account &&
    userContext.invitation_account.photobooks_onboarding_completed;

  return showOrdersAndDrafts ? [shopAlbums, albumsOrdersAndDrafts] : [shopAlbums];
};
